import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faChevronLeft,
	faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "../../../../../hooks";
import styles from "./CalendarWidget.module.css";

const CalendarWidget = () => {
	const { t } = useTranslation();
	const [currentDate, setCurrentDate] = useState(new Date());

	// Array of month keys for translation
	const monthKeys = [
		"january",
		"february",
		"march",
		"april",
		"may",
		"june",
		"july",
		"august",
		"september",
		"october",
		"november",
		"december",
	];

	// Translated day names (Mon-Sun)
	const daysOfWeek = [
		t("calendar.daysOfWeek.monday"),
		t("calendar.daysOfWeek.tuesday"),
		t("calendar.daysOfWeek.wednesday"),
		t("calendar.daysOfWeek.thursday"),
		t("calendar.daysOfWeek.friday"),
		t("calendar.daysOfWeek.saturday"),
		t("calendar.daysOfWeek.sunday"),
	];

	const getDaysInMonth = (date) => {
		const year = date.getFullYear();
		const month = date.getMonth();
		return new Date(year, month + 1, 0).getDate();
	};

	const handlePreviousMonth = () => {
		setCurrentDate(
			new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
		);
	};

	const handleNextMonth = () => {
		setCurrentDate(
			new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)
		);
	};

	// Get translated month name
	const getTranslatedMonth = (monthIndex) => {
		return t(`calendar.months.${monthKeys[monthIndex]}`);
	};

	const renderDays = () => {
		const days = [];
		const firstDayOfMonth = new Date(
			currentDate.getFullYear(),
			currentDate.getMonth(),
			1
		).getDay();
		const startDay = firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1;
		const daysInMonth = getDaysInMonth(currentDate);
		const today = new Date();

		// Empty days before the first day of the month
		for (let i = 0; i < startDay; i++) {
			days.push(
				<div key={`empty-${i}`} className={styles.calendarDayEmpty}></div>
			);
		}

		// Actual days of the month
		for (let day = 1; day <= daysInMonth; day++) {
			const isToday =
				today.getDate() === day &&
				today.getMonth() === currentDate.getMonth() &&
				today.getFullYear() === currentDate.getFullYear();

			days.push(
				<div
					key={day}
					className={`${styles.calendarDay} ${isToday ? styles.today : ""}`}
				>
					{day}
				</div>
			);
		}

		return days;
	};

	return (
		<div className={styles.calendarWidget}>
			<div className={styles.calendarHeader}>
				<button onClick={handlePreviousMonth} className={styles.arrowButton}>
					<FontAwesomeIcon icon={faChevronLeft} />
				</button>
				<span>
					{getTranslatedMonth(currentDate.getMonth())}{" "}
					{currentDate.getFullYear()}
				</span>
				<button onClick={handleNextMonth} className={styles.arrowButton}>
					<FontAwesomeIcon icon={faChevronRight} />
				</button>
			</div>
			<div className={styles.calendarDays}>
				{daysOfWeek.map((day) => (
					<div key={day} className={styles.calendarDayHeader}>
						{day}
					</div>
				))}
				{renderDays()}
			</div>
		</div>
	);
};

export default CalendarWidget;
